import { motion } from 'framer-motion';

export const DataPanel = ({ title, icon: Icon, children, className = '', color = '#5B21B6' }) => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    className={`bg-white rounded-xl border border-[#E2E8F0] shadow-sm overflow-hidden ${className}`}
  >
    <div className="px-4 py-3 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}15` }}>
          <Icon className="w-4 h-4" style={{ color }} weight="duotone" />
        </div>
        <h3 className="font-semibold text-[#0F172A] text-sm">{title}</h3>
      </div>
    </div>
    <div className="p-4">
      {children}
    </div>
  </motion.div>
);
